import { render, staticRenderFns } from "./showData.vue?vue&type=template&id=37893ec7&scoped=true"
import script from "./showData.vue?vue&type=script&lang=js"
export * from "./showData.vue?vue&type=script&lang=js"
import style0 from "./showData.vue?vue&type=style&index=0&id=37893ec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37893ec7",
  null
  
)

export default component.exports